import genericStore from "../generic_store";
import axios from "axios";
import { config } from "../../config/constants";
export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "notifications_request_cms",
        object: "notification_request_cms",
        header: [
            { text: "Usuario", value: "user" },
            { text: "Titulo", value: "title" },
            { text: "Leido", value: "is_read" },
            { text: "Nuevo", value: "is_new" },
            { text: "Mensaje", value: "message" },
            { text: "tipo", value: "type_notification" },
            { text: "Acciones", value: "actions", sortable: false }
        ],
        list_valid: [],
        list:[],
        total_not_read:0,
        total_valid:0,
        options: {
            sortBy: ["_id"],
            sortDesc: [false],
        },
    },
    mutations: {
        ...genericStore.mutations,
        success(state, data) {            
            state.status = "success";

            if (data && data["list"]) {
                state.list = data["list"];
            }
            if (data && data["list_valid"]) {
                state.list_valid = data["list_valid"];
            }
            if (data && (data["total_not_read"] ||  data["total_not_read"] == 0)) {
                state.total_not_read = data["total_not_read"];
            }

            if (data && data["total"]) {
                state.total = data["total"];
            }
            if (data && (data["total_valid"] || data["total_valid"] == 0)) {
                state.total_valid = data["total_valid"];
            }
        },
        empty(state) {
            state.list_valid = []
        },
    },
    actions: {
        ...genericStore.actions,
        getListAllNotifications({ commit, state }, options) {
            return new Promise((resolve, reject) => {
                commit("request");

                let filter = {
                    ...options,
                    search: "",
                };

                axios
                    .get(config.api_url + state.endpoint+"_all", { params: filter })
                    .then((response) => {
                        const newItems = response.data;
                        const currentList = options.page > 1 ? state.list_valid : []; // si es primera página, reemplaza

                        commit("success", {
                            list_valid: [...currentList, ...newItems],
                            total_not_read: parseInt(response.headers["total-not-read"]),
                            total_valid: parseInt(response.headers["pagination-count"]),
                        });
                        resolve(newItems);
                    })
                    .catch((err) => {
                        commit("error");
                        reject(err);
                    });
            });
        },
        clearNotifications({ commit, state }, data) {
            return new Promise((resolve, reject) => {
              commit("request");
              axios
                .post(config.api_url + "clear_notifications" , data)
                .then((response) => {
                    commit("success");
                    resolve(response.data);
                })
                .catch((error) => {
                  commit("error");
                  reject(error.response.data);
                });
            });
        },
        empty({ commit }) {
            return new Promise((resolve, reject) => {
                commit("empty");
            });
        },
    },
    getters: {
        ...genericStore.getters,
    },
};
